import React from 'react';
import { connect } from 'react-redux';
import SaveTokenDialog from './SaveTokenDialog';
import TokenDeletionDialog from './TokenDeletionDialog';
import TokenDisableDialog from './TokenDisableDialog';

const TokenDialogs = ({
  allowDelete,
  allowDisable,
  allowSave,
  theme,
}) => (
  <>
    {allowDelete && (<TokenDeletionDialog theme={theme} />)}
    {allowDisable && (<TokenDisableDialog theme={theme} />)}
    {allowSave && (<SaveTokenDialog theme={theme} />)}
  </>
);

const mapStateToProps = ({
  auth: { role: { permissions: { users, tokens } } },
  tokens: { activeToken, deleteTokenOpen, disableTokenOpen },
}) => ({
  allowDelete: deleteTokenOpen && (tokens.destroy || users.token_destroy),
  allowDisable: disableTokenOpen && (tokens.disable || users.token_disable),
  allowSave: activeToken.open && users.token_create,
});

export default connect(mapStateToProps)(TokenDialogs);
